import { Component, Input } from '@angular/core';

export interface TableColumn {
  label: string;
  key: string;
  sortable?: boolean;
  width?: string;
  format?: string;
}

@Component({
  selector: 'cmp-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent {
  @Input() columns: TableColumn[] = [];
  @Input() data: any[] = [];
}
